import React, { Component } from 'react';
import '../../styles/SolicitarPortabilidad.scss';
import { Typography, IconButton, Dialog, DialogContent, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import TextRipleyComponent from './TextRipleyComponent';
import * as ValidationUtils from '../../utils/ValidationUtils';
import { Info, Close } from '@material-ui/icons';
import AutoCompletar from './AutoCompletar';

const SI = 'SI';
const NO = 'NO';
const NO_ESPECIFICADO = 'N/A';
const numeros = [
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
];

export default class CompromisoDeudaLineasComponent extends Component {
  constructor(props) {
    super(props);
    const datosProductos = props.datosProductos;
    this.state = {
      openDetalle: false,
      datosProductos: datosProductos,
      infoConpromiso: false,
    };
    this.doValidation();
  }

  onComponentDidMount = () => {
    this.doValidation();
  };

  onchangeTieneProducto = (evt) => {
    const value = evt.target.value;
    this.setState(
      (prevState) => ({
        datosProductos: {
          ...prevState.datosProductos,
          tieneProducto: value ?? NO,
          numeroProductos: value === NO ? 0 : prevState.numeroProductos,
          montosProductos: value === NO ? [] : prevState.montosProductos,
          compromisoProductos: value === NO ? NO_ESPECIFICADO : prevState.compromisoProductos,
        }
      }),
      this.doValidation
    );
  };

  onChangeCompromisoProducto = (evt) => {
    const value = evt.target.value;
    this.setState(
      (prevState) => ({
        datosProductos: {
          ...prevState.datosProductos,
          compromisoProductos: value,
          numeroProductos: value === NO ? 0 : prevState.numeroProductos,
          montosProductos: value === NO ? [] : prevState.montosProductos,
        }
      }),
      this.doValidation
    );
  };

  getClassForRadio = (value) => {
    let result = 'none';
    if (value) {
      result = 'bordeDestacado';
    }
    return result;
  };

  onChangeNumeroProductos = (combo, value) => {
    this.setState(
      (prevState) =>({
        ...prevState.datosProductos,
        datosProductos: {
          numeroProductos: value,
        }
      }),
      this.doValidation);
  };

  onChangeMontoMaximoDeuda = (evt) => {
    const num = evt.target.value;
    let datosProductos = this.state.datosProductos;
    let montos;
    let value = null;
    if (num) {
      value = ValidationUtils.unformat(num);
      montos = this.state.datosProductos.montosProductos;
      if (ValidationUtils.isNumberOrEmpty(value)) {
        montos[evt.target.id] = value;
        datosProductos.montosProductos = montos;
        this.setState(
          {
            datosProductos,
          },
          this.doValidation
        );
      }
    } else {
      montos = this.state.datosProductos.montosProductos;
      montos[evt.target.id] = value;
      datosProductos.montosProductos = montos;
      this.setState(
        {
          datosProductos,
        },
        this.doValidation
      );
    }
  };

  renderDetalleCompromisoProducto = (numeroProductos) => {
    let result;
    result = (
      <div>
        {numeros.map((item) => { // eslint-disable-line
          let r;
          if (item.value <= numeroProductos) {
            let value = this.state.datosProductos.montosProductos[item.value];
            if (!value) {
              value = '';
            }
            const id = item.value + '';
            r = (
              <div className="contenedorTextRipley contenedorMonto" key={item.value}>
                <TextRipleyComponent
                  className="TextRipley"
                  label={'Monto máximo Deuda (' + this.props.nombreProducto + ' ' + item.value + ')'}
                  id={id}
                  onChange={this.onChangeMontoMaximoDeuda}
                  value={ValidationUtils.formatMonto(value)}
                  fullWidth={true}
                />
                <div className="montoMaximoDeudaPeso">$</div>
              </div>
            );
          }
          return r;
        })}
      </div>
    );
    return result;
  };

  renderNumeroProductos = (compromiso) => {
    let result;
    if (compromiso === SI) {
      result = (
        <div className="nTarjetas">
          <Typography className="tituloStepSolicitud">¿Cuántas {this.props.nombreProducto}s de Crédito tienes?</Typography>
          <div className="autoCompletar">
            <AutoCompletar
              id="cmbNumeroProductos"
              options={numeros}
              valor={this.state.datosProductos.numeroProductos}
              placeholder="seleccione"
              handleChange={this.onChangeNumeroProductos}
            ></AutoCompletar>
          </div>
        </div>
      );
    }
    return result;
  };
  renderCompromisoProducto = (tieneProducto, compromiso, numeroProductos) => {
    let result;
    const classNo = this.getClassForRadio(compromiso === NO);
    const classSi = this.getClassForRadio(compromiso === SI);
    if (tieneProducto === SI) {
      result = (
        <div>
          <Typography className="tituloStepSolicitud">
            ¿Puedes comprometerte a no aumentar la deuda de tu(s) {this.props.nombreProducto}(s) de crédito?
            <IconButton color="primary" className="btnInfoCompromiso" onClick={() => {this.setState({ infoConpromiso: true });}}>
              <Info />
            </IconButton>
          </Typography>
          <RadioGroup aria-label="gender" name="gender1" className="opcionesCompromiso Grande" value={this.state.datosProductos.compromisoProductos} onChange={this.onChangeCompromisoProducto}>
            <FormControlLabel control={<Radio color="primary" />} label="me comprometo" className={classSi} value={SI} />
            <FormControlLabel control={<Radio color="primary" />} label="no me comprometo" className={classNo} value={NO} />
          </RadioGroup>
          {this.renderNumeroProductos(compromiso)}
          {this.renderDetalleCompromisoProducto(numeroProductos)}
        </div>
      );
    }
    return result;
  };

  doValidation = () => {
    const result = this.validate();
    if (this.props.onValidation) {
      this.props.onValidation(result, this.state.datosProductos);
    }
  };

  validate = () => {
    if (this.state.datosProductos.tieneProducto === NO_ESPECIFICADO) {
      return false;
    }
    if (this.state.datosProductos.tieneProducto === SI && this.state.datosProductos.compromisoProductos === NO_ESPECIFICADO) {
      return false;
    }
    if (this.state.datosProductos.compromisoProductos === SI) {
      if (this.state.datosProductos.numeroProductos === 0) {
        return false;
      } else {
        let montosValidos = true;
        for (let i = 1; i <= this.state.datosProductos.numeroProductos; i++) {
          montosValidos &= !isNaN(this.state.datosProductos.montosProductos[i]) && this.state.datosProductos.montosProductos[i] > 0;
        }
        return montosValidos;
      }
    }
    return true;
  };

  closeDetalle = () => {
    this.setState({ infoConpromiso: false });
  };

  render() {
    const classNo = this.getClassForRadio(this.state.datosProductos.tieneProducto === NO);
    const classSi = this.getClassForRadio(this.state.datosProductos.tieneProducto === SI);
    return (
      <div>
        <div className="tienesTC">
          <Typography className="tituloStepSolicitud">¿Tienes {this.props.nombreProducto} de Crédito?</Typography>
          <RadioGroup aria-label="gender" name="gender1" className="opcionesCompromiso Grande" value={this.state.datosProductos.tieneProducto} onChange={this.onchangeTieneProducto}>
            <FormControlLabel control={<Radio color="primary" />} label="si" className={classSi} value={SI} />
            <FormControlLabel control={<Radio color="primary" />} label="no" className={classNo} value={NO} />
          </RadioGroup>
        </div>
        {this.renderCompromisoProducto(this.state.datosProductos.tieneProducto, this.state.datosProductos.compromisoProductos, this.state.datosProductos.numeroProductos)}
        <Dialog open={this.state.infoConpromiso}>
          <DialogContent>
            <div className="cerrarBtnModal">
              <IconButton onClick={this.closeDetalle}>
                <Close></Close>
              </IconButton>
            </div>
            <Typography className="tituloModalCarnet">Compromiso no aumentar deuda</Typography>
            <Typography>
              Debes indicar el monto máximo del cupo de tu tarjeta o línea de crédito el cual deseas utilizar antes de realizar la portabilidad de tu producto. Con este compromiso, nos das las
              facultades para que pidamos a tu banco actual que bloqueen tu Tarjeta de crédito o Línea de crédito con el fin de no aumentar tu deuda. En caso de no cumplimiento del compromiso por
              parte del solicitante, Banco Ripley puede retractarse de la oferta, incluso cuando ésta ya haya sido aceptada por el cliente.
            </Typography>
          </DialogContent>
          <div>
            <div className="franjaColores">
              <div className="rojo" />
              <div className="amarillo" />
              <div className="morado" />
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

CompromisoDeudaLineasComponent.defaultProps = {
  datosProductos: {
    montoMaximoDeuda: 0,
    tieneProducto: NO_ESPECIFICADO,
    numeroProductos: 0,
    montosProductos: [],
    compromisoProductos: NO_ESPECIFICADO,
  },
};
